import { render, staticRenderFns } from "./ResourceAccessChart.vue?vue&type=template&id=2366b038&scoped=true"
import script from "./ResourceAccessChart.vue?vue&type=script&lang=js"
export * from "./ResourceAccessChart.vue?vue&type=script&lang=js"
import style0 from "./ResourceAccessChart.vue?vue&type=style&index=0&id=2366b038&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2366b038",
  null
  
)

export default component.exports